import React from 'react';

import { Route as BaseRoute, Redirect } from 'react-router-dom';
import { NavigationElement } from 'modules/shared/models';
import { SubRouterProps } from 'modules/shared/types';
import { concatUrl } from 'modules/shared/utils';
import { Switch, NotifiedRoute, NotFound } from 'modules/shared/components';

import { ModuleSelector } from './components';

export const Router: React.FC<SubRouterProps> = ({ navigationTree, sourceStructureNode }: SubRouterProps) => {
    if (!sourceStructureNode || !sourceStructureNode.nodes || sourceStructureNode.nodes.length === 0) {
        return <React.Fragment />;
    }
    return (
        <Switch>
            <React.Fragment>
                {(sourceStructureNode.nodes || [])
                    .filter(n => n.path && (n.isModuleEntry || n.isRedirect || n.isCMS))
                    .map(node => {
                        const currentNavigationTree: NavigationElement = {
                            path: concatUrl([navigationTree.path, node.path ? node.path : '']),
                            parent: navigationTree,
                            isModule: node.isModuleEntry,
                            bannerId: node.bannerId,
                        };
                        return (
                            <NotifiedRoute
                                key={node.path}
                                structureNode={node}
                                navigationTree={currentNavigationTree}
                                path={currentNavigationTree.path}
                                exact={node.isRedirect}
                                render={() => {
                                    if (node.isRedirect) {
                                        return <Redirect to={node.contentTemplate ? node.contentTemplate : ''} />;
                                    }

                                    return (
                                        <ModuleSelector structureNode={node} navigationTree={currentNavigationTree} />
                                    );
                                }}
                            />
                        );
                    })}
            </React.Fragment>
            <BaseRoute component={NotFound} />
        </Switch>
    );
};
